import type { ComputedRef } from 'vue';
import type { PageRootContext } from '#layers/block-engine/public';
import { computed } from 'vue';
import { useBlockContext } from '#layers/block-engine/public';

/**
 * Display mode of the page hosting the current block: set when the page is shown in a drawer or
 * modal, where navigating would move the page underneath while the overlay stays open on top.
 */
export function usePageDisplayMode(): ComputedRef<PageRootContext['pageDisplayMode']> {
	const { getRootContext } = useBlockContext();

	return computed(() => (getRootContext() as PageRootContext).pageDisplayMode);
}
